import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Go to the Home Page and find new gym exercises today!", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeCarousel',
  setup(__props) {

const items = ref(['https://i.ibb.co/Pg3Ly1C/carousel-image-1.jpg',
        'https://i.ibb.co/TrnGMws/carousel-image-2.jpg',
        'https://i.ibb.co/j9Xn1C4/carousel-image-3.jpg'])

return (_ctx: any,_cache: any) => {
  const _component_va_carousel = _resolveComponent("va-carousel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_va_carousel, {
      items: items.value,
      height: "600px",
      style: {"max-width":"1000px"},
      indicators: false,
      arrows: false,
      stateful: "",
      autoscroll: "",
      autoscrollInterval: 6000
    }, null, 8, ["items"]),
    _hoisted_1,
    _hoisted_2,
    _hoisted_3
  ], 64))
}
}

})